import { alertCodes } from '../../utils/alertCodes';
import i18n from '../../i18n/config';

let alertFn = null;

export const setAlertHandler = (fn) => {
  alertFn = fn;
};

const triggerAlert = (message, type = 'error') => {
  if (alertFn) {
    alertFn(message, type);
  } else {
    console.warn('Alert handler not set. Please set it using setAlertHandler.');
  }
};

export const showAlert = (code) => {
  const lang = i18n.language || 'en';
  const alertData = alertCodes[code] || alertCodes.DEFAULT;
  const message = alertData[lang] || alertData.en;
  const type = alertData.type || 'error';
  triggerAlert(message, type);
};
